import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Grid, Typography, Button, useMediaQuery } from '@material-ui/core';

// CONSTANTS
import { ROUTE_LIVE_TV } from '@/constants/routes';

// UTILITY
import { getS3ImageUrl } from '@/utility/content';

// COMPONENTS
import Link from '@/components/Link';

// STYLES
import { Container } from './styles';

const bannerImg = getS3ImageUrl('/live-tv/live-tv-banner.png');
const bannerImgMob = getS3ImageUrl('/live-tv/live-tv-banner-mob.png');

const BannerLiveTv = () => {
  const [t] = useTranslation();
  const downXs = useMediaQuery(({ breakpoints }) => breakpoints.down('xs'));
  const { isIframe } = useSelector(({ app }) => ({
    isIframe: app.isIframe,
  }));

  return (
    <Container className="banner-live-tv">
      <div className="banner-live-tv__bg-top" />
      <div className="banner-live-tv__bg-bottom" />
      <Grid className="banner-live-tv__content" container spacing={3}>
        <Grid item xs={12} sm={6} md={5}>
          <Typography className="banner-live-tv__title text-bold" variant="h2">
            {t('bannerLiveTV.title')}
          </Typography>
          <Typography className="banner-live-tv__subtitle" color="textSecondary">
            {t('bannerLiveTV.subtitle')}
          </Typography>
          <Button
            className="banner-live-tv__button"
            size="large"
            color="primary"
            component={Link}
            to={ROUTE_LIVE_TV}
            target={isIframe ? '_blank' : '_self'}
            withoutIframe
          >
            {t('buttons.watchFree')}
          </Button>
        </Grid>
        <Grid item xs={12} sm={6} md={7}>
          <div className="banner-live-tv__image">
            <img src={downXs ? bannerImgMob : bannerImg} alt="banner" />
          </div>
        </Grid>
      </Grid>
    </Container>
  );
};

export default React.memo(BannerLiveTv);
